var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPossiblePerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5925 3.02719C14.6803 2.04234 13.4062 1.5 12 1.5C10.5862 1.5 9.30797 2.03906 8.4 3.01781C7.48219 4.00734 7.035 5.35219 7.14 6.80438C7.34812 9.66938 9.52828 12 12 12C14.4717 12 16.6481 9.66984 16.8595 6.80531C16.9659 5.36625 16.5159 4.02422 15.5925 3.02719Z",
    fill: "#5F6C8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 22.5H3.74999C3.53402 22.5028 3.32014 22.4574 3.12391 22.3672C2.92768 22.2769 2.75404 22.1441 2.61562 21.9783C2.31093 21.6141 2.18812 21.1167 2.27906 20.6138C2.67468 18.4191 3.90937 16.5755 5.84999 15.2812C7.57406 14.1323 9.75796 13.5 12 13.5C14.242 13.5 16.4259 14.1328 18.15 15.2812C20.0906 16.575 21.3253 18.4186 21.7209 20.6133C21.8119 21.1163 21.6891 21.6136 21.3844 21.9778C21.246 22.1437 21.0724 22.2766 20.8761 22.367C20.6799 22.4573 20.466 22.5028 20.25 22.5Z",
    fill: "#5F6C8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPossiblePerson);
export default __webpack_public_path__ + "static/media/possible_person.1c8719d5f61ce308175edae142127b9a.svg";
export { ForwardRef as ReactComponent };